import React, { useEffect, useState } from 'react';

const RequestReworkModal = ({ open, task, onClose, onSubmit, submitting = false }) => {
    const [reason, setReason] = useState('');
    const [error, setError] = useState('');

    useEffect(() => {
        if (open) {
            setReason('');
            setError('');
        }
    }, [open, task?.id]);

    if (!open) return null;

    const handleSubmit = (event) => {
        event.preventDefault();
        const trimmed = reason.trim();
        if (!trimmed) {
            setError('Enter what needs to be revised.');
            return;
        }
        onSubmit?.({ reason: trimmed });
    };

    return (
        <div className="fixed inset-0 z-[80] flex items-center justify-center bg-black/50 p-4">
            <div
                className="w-full max-w-lg rounded-2xl border border-zinc-200 bg-white p-5 shadow-xl dark:border-zinc-700 dark:bg-zinc-950"
                role="dialog"
                aria-modal="true"
                aria-labelledby="request-rework-title"
            >
                <div className="flex items-start gap-3">
                    <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl border border-amber-200 bg-amber-50 text-amber-700 dark:border-amber-500/30 dark:bg-amber-500/10 dark:text-amber-200">
                        <i className="fa-solid fa-rotate text-sm" />
                    </span>
                    <div className="min-w-0">
                        <h2
                            id="request-rework-title"
                            className="text-lg font-semibold text-zinc-900 dark:text-white"
                        >
                            Request rework
                        </h2>
                        <p className="mt-1 text-sm leading-relaxed text-zinc-500 dark:text-zinc-400">
                            Tell the employee what needs to change before they resubmit.
                            This will pause the review timer and requires wallet confirmation.
                        </p>
                    </div>
                </div>

                {task?.title ? (
                    <div className="mt-4 rounded-xl border border-zinc-200 bg-zinc-50 px-3 py-2 text-sm text-zinc-700 dark:border-zinc-800 dark:bg-zinc-900/50 dark:text-zinc-300">
                        <span className="text-xs font-semibold uppercase tracking-wide text-zinc-500">
                            Task
                        </span>
                        <p className="mt-0.5 font-medium">{task.title}</p>
                    </div>
                ) : null}

                <form onSubmit={handleSubmit} className="mt-4 space-y-4">
                    <label className="block space-y-1.5">
                        <span className="text-xs font-medium text-zinc-600 dark:text-zinc-400">
                            Rework instructions
                        </span>
                        <textarea
                            value={reason}
                            onChange={(event) => {
                                setReason(event.target.value);
                                if (error) setError('');
                            }}
                            rows={5}
                            placeholder="Example: Please fix the mobile layout and attach updated screenshots."
                            className="cpg-input min-h-[120px] w-full resize-y"
                            disabled={submitting}
                            autoFocus
                        />
                        {error ? (
                            <p className="text-xs text-rose-600 dark:text-rose-400">
                                {error}
                            </p>
                        ) : null}
                    </label>

                    <div className="flex flex-wrap justify-end gap-2 pt-1">
                        <button
                            type="button"
                            onClick={onClose}
                            disabled={submitting}
                            className="rounded-lg border border-zinc-200 px-4 py-2 text-sm font-semibold text-zinc-700 transition hover:bg-zinc-50 disabled:opacity-50 dark:border-zinc-700 dark:text-zinc-300 dark:hover:bg-zinc-900"
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            disabled={submitting || !reason.trim()}
                            className="rounded-lg bg-amber-600 px-4 py-2 text-sm font-semibold text-white transition hover:bg-amber-700 disabled:opacity-50"
                        >
                            {submitting ? 'Requesting…' : 'Continue to wallet'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default RequestReworkModal;
